import mitt from "mitt";
import {AlertMessageInterface} from "@/utils/AlertMessageInterface";

export type EventBus = {
    alert: AlertMessageInterface
}

export const bus = mitt<EventBus>()